import { collection, query, where, getDocs } from 'firebase/firestore';

// Validation des numéros de téléphone ivoiriens
export function validateIvorianPhone(phone: string): boolean {
  // Nettoyer le numéro de téléphone
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Vérifier la longueur (10 chiffres)
  if (cleanPhone.length !== 10) return false;
  
  // Vérifier le préfixe (01, 05, 07)
  const prefix = cleanPhone.substring(0, 2);
  const validPrefixes = ['01', '05', '07'];
  
  return validPrefixes.includes(prefix);
}

// Formater le numéro de téléphone
export function formatIvorianPhone(phone: string): string {
  const cleanPhone = phone.replace(/\D/g, '');
  if (cleanPhone.length !== 10) return phone;
  
  return cleanPhone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
}

// Vérifier si l'email existe déjà
export async function isEmailUnique(email: string, db: any, currentUserId?: string): Promise<boolean> {
  console.log('🔍 Checking email uniqueness for:', email, 'excluding user ID:', currentUserId);
  
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('email', '==', email.toLowerCase()));
  const querySnapshot = await getDocs(q);
  
  console.log('📋 Found documents with this email:', querySnapshot.docs.length);
  
  // Si on est en mode édition, on exclut l'utilisateur courant
  if (currentUserId) {
    // Filtrer pour exclure l'utilisateur actuel
    const otherUserDocs = querySnapshot.docs.filter(doc => doc.id !== currentUserId);
    console.log('⚖️ Documents from OTHER users:', otherUserDocs.length);
    
    // L'email est unique si aucun autre utilisateur ne l'utilise
    return otherUserDocs.length === 0;
  }
  
  return querySnapshot.empty;
}

// Vérifier si le téléphone existe déjà
export async function isPhoneUnique(phone: string, db: any, currentUserId?: string): Promise<boolean> {
  console.log('📞 Checking phone uniqueness for:', phone, 'excluding user ID:', currentUserId);
  
  const cleanPhone = phone.replace(/\D/g, '');
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('phone', '==', cleanPhone));
  const querySnapshot = await getDocs(q);
  
  console.log('📋 Found documents with this phone:', querySnapshot.docs.length);
  
  // Si on est en mode édition, on exclut l'utilisateur courant
  if (currentUserId) {
    // Filtrer pour exclure l'utilisateur actuel
    const otherUserDocs = querySnapshot.docs.filter(doc => doc.id !== currentUserId);
    console.log('⚖️ Documents from OTHER users:', otherUserDocs.length);
    
    // Le téléphone est unique si aucun autre utilisateur ne l'utilise
    return otherUserDocs.length === 0;
  }
  
  return querySnapshot.empty;
}